import { render, staticRenderFns } from "./informationinfo.vue?vue&type=template&id=3af5d720&scoped=true"
import script from "./informationinfo.vue?vue&type=script&lang=js"
export * from "./informationinfo.vue?vue&type=script&lang=js"
import style0 from "./informationinfo.vue?vue&type=style&index=0&id=3af5d720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5d720",
  null
  
)

export default component.exports